"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Business = _interopRequireDefault(require("../model/Business"));
var _BusinessLevel = _interopRequireDefault(require("../model/BusinessLevel"));
var _Customer = _interopRequireDefault(require("../model/Customer"));
var _Employee = _interopRequireDefault(require("../model/Employee"));
var _Message = _interopRequireDefault(require("../model/Message"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* OrganizationBusiness service.
* @module api/OrganizationBusinessApi
* @version 3.0
*/
var OrganizationBusinessApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new OrganizationBusinessApi. 
  * @alias module:api/OrganizationBusinessApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function OrganizationBusinessApi(apiClient) {
    _classCallCheck(this, OrganizationBusinessApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create a new Business Employee
   * Create a new Employee for the Business.
   * @param {Number} businessId ID of the business
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Employee} and HTTP response
   */
  return _createClass(OrganizationBusinessApi, [{
    key: "createBusinessEmployeeWithHttpInfo",
    value: function createBusinessEmployeeWithHttpInfo(businessId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling createBusinessEmployee");
      }
      var pathParams = {
        'businessId': businessId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Employee["default"];
      return this.apiClient.callApi('/businesses/{businessId}/employees', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a new Business Employee
     * Create a new Employee for the Business.
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Employee}
     */
  }, {
    key: "createBusinessEmployee",
    value: function createBusinessEmployee(businessId) {
      return this.createBusinessEmployeeWithHttpInfo(businessId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a new Business Level
     * Create a new Level for the Business.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessLevel} and HTTP response
     */
  }, {
    key: "createBusinessLevelWithHttpInfo",
    value: function createBusinessLevelWithHttpInfo(businessId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling createBusinessLevel");
      }
      var pathParams = {
        'businessId': businessId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _BusinessLevel["default"];
      return this.apiClient.callApi('/businesses/{businessId}/levels', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a new Business Level
     * Create a new Level for the Business.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessLevel}
     */
  }, {
    key: "createBusinessLevel",
    value: function createBusinessLevel(businessId) {
      return this.createBusinessLevelWithHttpInfo(businessId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a new Business Level
     * Create a new Business Level underneath the selected Level.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessLevel} and HTTP response
     */
  }, {
    key: "createBusinessSubLevelWithHttpInfo",
    value: function createBusinessSubLevelWithHttpInfo(businessId, levelId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling createBusinessSubLevel");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling createBusinessSubLevel");
      }
      var pathParams = {
        'businessId': businessId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _BusinessLevel["default"];
      return this.apiClient.callApi('/businesses/{businessId}/levels/{levelId}/levels', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a new Business Level
     * Create a new Business Level underneath the selected Level.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessLevel}
     */
  }, {
    key: "createBusinessSubLevel",
    value: function createBusinessSubLevel(businessId, levelId) {
      return this.createBusinessSubLevelWithHttpInfo(businessId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Business details
     * Gets the Details for the selected Business.
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Business} and HTTP response
     */
  }, {
    key: "getBusinessWithHttpInfo",
    value: function getBusinessWithHttpInfo(businessId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling getBusiness");
      }
      var pathParams = {
        'businessId': businessId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Business["default"];
      return this.apiClient.callApi('/businesses/{businessId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Business details
     * Gets the Details for the selected Business.
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Business}
     */
  }, {
    key: "getBusiness",
    value: function getBusiness(businessId) {
      return this.getBusinessWithHttpInfo(businessId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Business Employees
     * Gets all the Employees inside of the Business Level.
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Employee>} and HTTP response
     */
  }, {
    key: "getBusinessEmployeesWithHttpInfo",
    value: function getBusinessEmployeesWithHttpInfo(businessId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling getBusinessEmployees");
      }
      var pathParams = {
        'businessId': businessId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Employee["default"]];
      return this.apiClient.callApi('/businesses/{businessId}/employees', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Business Employees
     * Gets all the Employees inside of the Business Level.
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Employee>}
     */
  }, {
    key: "getBusinessEmployees",
    value: function getBusinessEmployees(businessId) {
      return this.getBusinessEmployeesWithHttpInfo(businessId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Business Level details
     * Gets the details for the Business Level.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessLevel} and HTTP response
     */
  }, {
    key: "getBusinessLevelWithHttpInfo",
    value: function getBusinessLevelWithHttpInfo(businessId, levelId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling getBusinessLevel");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling getBusinessLevel");
      }
      var pathParams = {
        'businessId': businessId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _BusinessLevel["default"];
      return this.apiClient.callApi('/businesses/{businessId}/levels/{levelId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Business Level details
     * Gets the details for the Business Level.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessLevel}
     */
  }, {
    key: "getBusinessLevel",
    value: function getBusinessLevel(businessId, levelId) {
      return this.getBusinessLevelWithHttpInfo(businessId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Business Level Employees
     * Gets the Business Level Employees
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Employee>} and HTTP response
     */
  }, {
    key: "getBusinessLevelEmployeesWithHttpInfo",
    value: function getBusinessLevelEmployeesWithHttpInfo(businessId, levelId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling getBusinessLevelEmployees");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling getBusinessLevelEmployees");
      }
      var pathParams = {
        'businessId': businessId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Employee["default"]];
      return this.apiClient.callApi('/businesses/{businessId}/levels/{levelId}/employees', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Business Level Employees
     * Gets the Business Level Employees
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Employee>}
     */
  }, {
    key: "getBusinessLevelEmployees",
    value: function getBusinessLevelEmployees(businessId, levelId) {
      return this.getBusinessLevelEmployeesWithHttpInfo(businessId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Levels under a specified Business Level
     * Gets the Levels which are under the selected Business Level.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BusinessLevel>} and HTTP response
     */
  }, {
    key: "getBusinessLevelSubLevelsWithHttpInfo",
    value: function getBusinessLevelSubLevelsWithHttpInfo(businessId, levelId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling getBusinessLevelSubLevels");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling getBusinessLevelSubLevels");
      }
      var pathParams = {
        'businessId': businessId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BusinessLevel["default"]];
      return this.apiClient.callApi('/businesses/{businessId}/levels/{levelId}/levels', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Levels under a specified Business Level
     * Gets the Levels which are under the selected Business Level.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the parent level
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BusinessLevel>}
     */
  }, {
    key: "getBusinessLevelSubLevels",
    value: function getBusinessLevelSubLevels(businessId, levelId) {
      return this.getBusinessLevelSubLevelsWithHttpInfo(businessId, levelId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Business Levels details
     * GGets a list of all the root Levels for the Business.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/BusinessLevel>} and HTTP response
     */
  }, {
    key: "getBusinessLevelsWithHttpInfo",
    value: function getBusinessLevelsWithHttpInfo(businessId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling getBusinessLevels");
      }
      var pathParams = {
        'businessId': businessId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_BusinessLevel["default"]];
      return this.apiClient.callApi('/businesses/{businessId}/levels', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Business Levels details
     * GGets a list of all the root Levels for the Business.<br>Levels are used to separate out Employees into different departments and can be used to limit visibility to specific Employees and set up management Employees for different Levels.<br>
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/BusinessLevel>}
     */
  }, {
    key: "getBusinessLevels",
    value: function getBusinessLevels(businessId) {
      return this.getBusinessLevelsWithHttpInfo(businessId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Business Level Customers
     * Gets all the Customers managed by the Business.
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Customer>} and HTTP response
     */
  }, {
    key: "getBusinessManagedCustomersWithHttpInfo",
    value: function getBusinessManagedCustomersWithHttpInfo(businessId) {
      var postBody = null;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling getBusinessManagedCustomers");
      }
      var pathParams = {
        'businessId': businessId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Customer["default"]];
      return this.apiClient.callApi('/businesses/{businessId}/customers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Business Level Customers
     * Gets all the Customers managed by the Business.
     * @param {Number} businessId ID of the business
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Customer>}
     */
  }, {
    key: "getBusinessManagedCustomers",
    value: function getBusinessManagedCustomers(businessId) {
      return this.getBusinessManagedCustomersWithHttpInfo(businessId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a level.
     * Modify the details of a Level. <br>If the parent Level Id is given in the body of the PUT then the Level will move to that parent Level.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the level
     * @param {module:model/BusinessLevel} businessLevel Level details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/BusinessLevel} and HTTP response
     */
  }, {
    key: "modifyBusinessLevelWithHttpInfo",
    value: function modifyBusinessLevelWithHttpInfo(businessId, levelId, businessLevel) {
      var postBody = businessLevel;
      // verify the required parameter 'businessId' is set
      if (businessId === undefined || businessId === null) {
        throw new Error("Missing the required parameter 'businessId' when calling modifyBusinessLevel");
      }
      // verify the required parameter 'levelId' is set
      if (levelId === undefined || levelId === null) {
        throw new Error("Missing the required parameter 'levelId' when calling modifyBusinessLevel");
      }
      // verify the required parameter 'businessLevel' is set
      if (businessLevel === undefined || businessLevel === null) {
        throw new Error("Missing the required parameter 'businessLevel' when calling modifyBusinessLevel");
      }
      var pathParams = {
        'businessId': businessId,
        'levelId': levelId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _BusinessLevel["default"];
      return this.apiClient.callApi('/businesses/{businessId}/levels/{levelId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a level.
     * Modify the details of a Level. <br>If the parent Level Id is given in the body of the PUT then the Level will move to that parent Level.<br>
     * @param {Number} businessId ID of the business
     * @param {Number} levelId ID of the level
     * @param {module:model/BusinessLevel} businessLevel Level details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/BusinessLevel}
     */
  }, {
    key: "modifyBusinessLevel",
    value: function modifyBusinessLevel(businessId, levelId, businessLevel) {
      return this.modifyBusinessLevelWithHttpInfo(businessId, levelId, businessLevel).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();